const OnboardingFormHeader = () => {
  return (
    <p className="font-satoshi-bold text-[20px] leading-[30px] text-black">
      Before you run your code, we will just need quick details from you
    </p>
  );
};

export default OnboardingFormHeader;
